<template>
    <header class="drag">
        <div class="search-box no-drag" style="width: calc( 100% - 59px)">
            <div style="display: flex;width: 100%">
                <div style="width: 90%;">
                    <search></search>
                </div>

<!--                <div style="width: 60%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">-->
<!--                    <marquee behavior="scroll" direction="left" onmouseover="this.stop()" onmouseout="this.start()">-->
<!--                        <span>在线：</span>-->
<!--                        <span v-for="item in currentUsers" :key="item.id" style="line-height: 25px">-->
<!--                            {{item.name}}<span style="margin-right: 5px"></span>-->
<!--                        </span>-->
<!--                    </marquee>-->
<!--                </div>-->


                <div style="width: 10%;">
                    <el-button size="mini" @click="handleLogOut">退出登陆</el-button>
                </div>
            </div>
        </div>
        <!--        <ul class="m-topbar__nav m-nav m-nav&#45;&#45;inline float-right">-->
        <!--            <li class="m-nav__item">-->
        <!--                <a class="m-nav__link">-->
        <!--<el-select  placeholder="请选择" size="mini">-->
        <!--<el-option-->
        <!--label="港隆校区"-->
        <!--value="港隆校区">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--                </a>-->
        <!--            </li>-->
        <!--        </ul>-->
    </header>
</template>

<script>
    import Search from '@/layouts/Search/Index'
    import store from '@/store'

    export default {
        name: "Header",
        data() {
            return {

            };
        },
        components: {
            search: Search
        },
        computed: {
            currentUsers() {
                return this.$store.state.config.currentUsers;
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'];
        },
        methods: {
            handleLogOut() {
                this.$wApi.Close();
                this.$store.commit('setPowers', {'powers': []});
                this.$store.commit('setSemester', {'semester': {}});
                this.$store.commit('setSection', {'section': {}});
                this.$store.commit('setConfig', {'config': ''});
                localStorage.token = null;
                store.commit('refreshToken', null);
                // window.location.href = "http://localhost:8080/";
                window.location.href = "https://web.xuezhi.app/"
                // this.$router.push({
                //     path: '/login'
                // });
            },
        }
    }
</script>

<style scoped lang="scss">
    header {
        .search-box {
            margin: 0;
            position: fixed;
            top: 0;
            left: 85px;
            display: flex;
            flex-direction: row;
            height: 40px;
            justify-content: center;
            align-items: center;
            z-index: 20;
        }

        margin-left: 59px;
        /*box-shadow: 0 1px 1px 1px rgba(18,106,211,.08);*/
        background: #fff;
        height: 40px;
    }


</style>
